import React from "react";
import { Bar, Line } from "react-chartjs-2";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend, Title, ChartOptions } from "chart.js";
import { trace } from "console";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

interface BarChartProps {
  labels: string[];
  dataSets: {
    label: string;
    data: number[];
    backgroundColor?: string;
    borderColor?: string;
  }[];
  title: string;
  xLabel: string;
  yLabel: string;
  barThickness?: number;
}

const BarChart: React.FC<BarChartProps> = ({ 
    labels, 
    dataSets, 
    title,
    xLabel,
    yLabel,
    barThickness
}) => {
  const data = {
    labels,
    datasets: dataSets.map((set) => ({
      label: set.label,
      data: set.data,
      backgroundColor: set.backgroundColor || "rgba(75, 192, 192, 0.5)",
      borderColor: set.borderColor || "rgba(75, 192, 192, 1)",
      borderWidth: 1,
      barPercentage: 0.9, 
      categoryPercentage: 0.6,
      barThickness: barThickness || 25,
    })),
  };
  ChartJS.register(Title);

  const options: ChartOptions<"bar"> = {
    responsive: true,
    plugins: {
      legend: { 
        display: true,
        position: 'bottom',
      },
      title: { 
        display: !!title, 
        text: title,
        align: "start",   
        color: '#14213d',    
        fullSize: true,    
        position: 'top',   
        font: {
          size: 15,       
          weight: 600, 
          family: 'Arial',  
          style: 'normal'  
        },
        padding: {
          bottom: 20,
        },
      },
    },
    scales: {
      x: {
        title: { 
          display: !!xLabel, 
          text: xLabel, 
          font: { size: 14 } 
          // categoryPercentage: 0.5, 
          // barPercentage: 0.5,
        },
        ticks: {
          maxRotation: 0,
          autoSkip: false
        },    
      },
      y: { 
        beginAtZero: true,
        title: {
          display: !!yLabel, 
          text: yLabel, 
          font: { size: 14 } 
        },
      },
    },
  };
  

  return <Bar data={data} options={options} />;
};

export default BarChart;
